import axios from 'axios';
import { environment } from '../environment/environment';

export const fetchUserPermissions = async () => {
  try {
    let token = localStorage.getItem('authToken');
    const response = await axios.get(`${environment.apiHostStartPoint}AdminUsers/permissions`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching permissions:', error);
    throw error;
  }
};
